var _g, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBandera = function SvgBandera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 500,
    viewBox: "0 0 72 36"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h72v36H0z",
    style: {
      fill: "#0073cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12h72v12H0z",
    style: {
      fill: "#fff"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    fill: "#0073cf",
    transform: "matrix(2 0 0 2 36 18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0v1h.5z",
    transform: "rotate(18 3.157 -.5)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#b",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#b",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#b",
    transform: "rotate(-144)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#c",
    transform: "translate(10 -3.2)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#c",
    transform: "translate(10 2.8)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#c",
    transform: "translate(-10 -3.2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#c",
    transform: "translate(-10 2.8)"
  })));
};
export default SvgBandera;